const themeSwitch = () => {
    const themeBtn = document.getElementsByClassName('header__theme');
    const htmlEl = document.getElementsByTagName('html')[0];
    if(themeBtn) {
        for(var i = 0; i < themeBtn.length; i++) {
            themeBtn[i].addEventListener('click',function() {
                if(htmlEl.dataset.theme == 'light') {
                    htmlEl.dataset.theme = "dark"
                    setCookie('theme','dark',365);
                } else {
                    htmlEl.dataset.theme = "light";
                    setCookie('theme','light',365);
                }
            })
        }
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }
}

export default themeSwitch;
